export class DefectManagementModel {

  JournalListApi: string = "";
  IssueAndArticlesListApi: string = "";
  DefectAreaList: string = "";
  DefectCategoryList: string = "";
  DefectInstructionList: string = "";
  DefectManagementList: string = "";
  PopulateDefectMgt: string = "";
  UpdateDefectManagement: string = "";
  DefectResponseDataApi: string = "";
  DefectFileUploadData: string = "";
  DefectFileDownloadApi: string ="";
  DefectCorrectedFileDownload: string ="";
  DefectDataFileDownloadApi: string ="";
  ReportTypeAPI: string = "";
  DefectStatusListAPI: string = "";
  

}
